/* istanbul ignore file */
/**
 * Created by rathompson on 11/3/21
 * File: ActionsRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Select, Button } from '@panwds/react-ui'
import { useContext, useMemo } from 'react'
import { SettingsIcon } from '@panwds/icons'
import {
  LABEL_ROLE_ACTION_EDIT,
  LABEL_ROLE_ACTION_CLONE,
  LABEL_ROLE_ACTION_DELETE,
} from '../../../../constants/LabelConstants'
import GlobalContext from '../../../../../common/context/GlobalContext'
import type { VFC } from 'react'
import type { RowInstance } from '@panwds/react-table'
import type { IAM_Role } from '../../../../../common/reducers/types/IAMReducer.types'
import { getVarValue } from '../../../../../common/utils/Sparky'
import { FF_CUSTOM_ROLES_API } from '../../../../../common/utils/FeatureFlags'

const enableCustomAPI = getVarValue(FF_CUSTOM_ROLES_API, null)


/**
 *   Table row actions button
 */
const ActionsRenderer: VFC<{
  row: RowInstance<IAM_Role>,
  onActionClick: Function
}> = ({ row, onActionClick }) => {

  const { iamReducer, treeReducer = {} } = useContext(GlobalContext)
  const { selectedTreeNode = {} } = treeReducer
  const { accessPolicies } = iamReducer

  const deleteDisabled = useMemo(() => {
    const { id, tsg_id } = row?.original || {}
    return selectedTreeNode?.id !== tsg_id || accessPolicies.some(policy => policy.role === id)
  }, [accessPolicies, row?.original, selectedTreeNode?.id])

  const editDisabled = useMemo(() => {
    const { tsg_id } = row?.original || {}
    return selectedTreeNode?.id !== tsg_id
  }, [row?.original, selectedTreeNode?.id])

  const items = useMemo(() => {
    return [
      { value: LABEL_ROLE_ACTION_EDIT, disabled: editDisabled },
      { value: LABEL_ROLE_ACTION_CLONE },
      { value: LABEL_ROLE_ACTION_DELETE, disabled: deleteDisabled }
    ].filter(item => (enableCustomAPI ? true : item.value !== LABEL_ROLE_ACTION_CLONE))
  }, [deleteDisabled, editDisabled])

  return (
    <Select
      addClassName='cmm-modal-select'
      fitToItemWidth
      items={items}
      button={(
        <Button aria-label='custom-role-action' appearance='tertiary-clear' icon={<SettingsIcon size='sm' />} />
      )}
      onChange={({ selectedItem }) => onActionClick(selectedItem.value, row.original)}
    />
  )
}

ActionsRenderer.propTypes = {}
export default ActionsRenderer
